module.exports = __webpack_public_path__ + "/images/cover-elige.74e6d2e.jpg";